export default __webpack_public_path__ + "static/media/corner-gpac.4cc724e3.webp";